const state = {
  tagsList: [],
  collapse: false,
  language: 'zh-cn',
  timezone:"+8",
  trackType:"0",
  trackNo:"",
  menuList: [
    {
      id: 1,
      code: 'home'
    },
    {
      id: 2,
      code: 'product'
    },
    {
      id: 3,
      code: 'service'
    },
    {
      id: 4,
      code: 'about'
    }
  ],
  loginMenuList: [
    {
      id: 6,
      code: 'dashboard',
      permission: 'dashboard:view'
    },
    {
      id: 2,
      code: 'order',
      permission: 'order:view'
    },
    {
      id: 1,
      code: 'booking',
      permission: 'booking:view'
    },
    {
      id: 7,
      code: 'mawb',
      permission: 'mawb:view'
    },
    {
      id: 5,
      code: 'customs',
      permission: 'customs:view'
    },
    {
      id: 3,
      code: 'bill',
      permission: 'bill:view'
    },
    {
      id: 4,
      code: 'my',
      permission: 'mine:view'
    },
    {
      id: 8,
      code: 'trust',
      permission: 'trust:view'
    },
    {
      id: 9,
      code: 'label',
      permission: 'label:view'
    },
    {
      id: 10,
      code: 'mawbOpt',
      permission: 'mawb-opt:view'
    },
    {
      id: 11,
      code: 'databoard',
      permission: 'databoard:view'
    },
    {
      id: 12,
      code: 'coa',
      permission: 'customs2:view'
    },
    {
      id: 13,
      code: 'hts',
      permission: 'hts:view'
    },
    {
      id: 14,
      code: 'tariff',
      permission: 'tariff:view'
    },
    {
      id: 15,
      code: 'mid',
      permission: 'customs2:view'
    },
  ]
}

const getters = {
  currentLocale (state) {
    return localStorage.getItem('locale') ? localStorage.getItem('locale') : state.language
  },

  currentTimeZone(state){
    return localStorage.getItem('timezone') ? localStorage.getItem('timezone') : state.timezone
  }

}

const mutations = {
  delTagsItem (state, data) {
    state.tagsList.splice(data.index, 1)
  },
  setTagsItem (state, data) {
    state.tagsList.push(data)
  },
  clearTags (state) {
    state.tagsList = []
  },
  closeTagsOther (state, data) {
    state.tagsList = data
  },
  closeCurrentTag (state, data) {
    for (let i = 0, len = state.tagsList.length; i < len; i++) {
      const item = state.tagsList[i]
      if (item.path === data.$route.fullPath) {
        if (i < len - 1) {
          data.$router.push(state.tagsList[i + 1].path)
        } else if (i > 0) {
          data.$router.push(state.tagsList[i - 1].path)
        } else {
          data.$router.push('/')
        }
        state.tagsList.splice(i, 1)
        break
      }
    }
  },
  // 侧边栏折叠
  hadndleCollapse (state, data) {
    state.collapse = data
  },

  // 设置语言
  setLanguage (state, data) {
    state.language = data
  },
  setTimeZone (state, data) {
    state.timezone = data
  },
  setTrackNo (state, data) {
    state.trackNo = data
  },
  setTrackType (state, data) {
    state.trackType = data
  },
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/system.js